import { doc, getDoc } from 'firebase/firestore';
import { err, ok, type Result } from '@shared/result';
import type { IBirthdayRepository, RepositoryError } from '@application/ports';
import type { Birthday } from '@domain/entities/Birthday';
import { decodeBirthdays } from '../codecs/birthday';
import { COLLECTIONS, firebase } from '../firebase/client';
import { translateFirestoreError } from './support';

/**
 * Los cumpleaños, leídos directo de `birthdayMonths/{01…12}`.
 *
 * Eran una callable que leía las 331 fichas en cada visita: 2.7 s cuando la
 * función arrancaba en frío, que con el tráfico del portal era casi siempre. Los
 * documentos los arma el servidor —un disparador por ficha y una reconstrucción
 * diaria— y las reglas dejan leerlos a cualquiera activo con Kn·Blog encendido.
 */
export class FirestoreBirthdayRepository implements IBirthdayRepository {
  async listMonth(month: number): Promise<Result<readonly Birthday[], RepositoryError>> {
    const id = String(month).padStart(2, '0');
    try {
      const { db } = firebase();
      const snapshot = await getDoc(doc(db, COLLECTIONS.birthdayMonths, id));
      /* Sin documento es un mes que todavía no se armó: nadie que celebrar. */
      if (!snapshot.exists()) return ok([]);
      const people = decodeBirthdays(snapshot.data()['people']);
      return ok(people.filter((birthday) => birthday.month === month));
    } catch (cause) {
      return err(translateFirestoreError(cause, `${COLLECTIONS.birthdayMonths}/${id}`));
    }
  }
}
